import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from "@angular/material/divider";
import { MatIconModule } from "@angular/material/icon";
import { Udxb2bAttraction } from "src/app/udxb2b/features/model";
import { AtractionEventComponent } from "./attraction-event.component";

@Component({
    selector: 'udx-cx-attraction-card-component',
    templateUrl: './attraction-card.component.html',
    imports: [MatDividerModule, MatDialogModule, MatIconModule, CommonModule, AtractionEventComponent],
    styleUrls: ['./attraction-card.component.scss']
})
  

export class AttractionCardComponent {
    @Input() product!: Udxb2bAttraction;
    @Input() allProducts!: Udxb2bAttraction[];
    @Input() shouldGroupProducts: boolean = false; // Will be used when subgroups need to have division
    @Input() key?: string;
    @Output() onSelectCardEvent = new EventEmitter<SelectCardEventPayload>();
    @Input() enableSelection = true; // Default

    onSelectCard(allProducts:Udxb2bAttraction[], product:Udxb2bAttraction) {
        if (this.enableSelection) {
            this.onSelectCardEvent.emit({
                data: allProducts,
                product: product
            });
        }
    }
}

export interface SelectCardEventPayload {
    data: Udxb2bAttraction[],
    product: Udxb2bAttraction
}
